$(function(){
	$('.my-faq h3').on( "click", function(e) {
		if($(this).is('.open')){
			$(this).removeClass('open').parent().find('.descri').slideUp('fast');
		}
		else{
			$(this).addClass('open').parent().find('.descri').slideDown('fast');
		}
	}); 	
});